import {
 fetchNoticesFail,
 fetchNoticesRequest,
 fetchNoticesSuccess
} from '../store/ActionReducers/notice.actionreducer';
import {Dispatch} from 'redux';
import { httpbase } from '../utils/axios.utils';
import { lang } from '../config/app.config';


export const fetchNotices = (page:number = 1,branch:string|null=null)=>{
  return async (dispatch:Dispatch) =>{
    dispatch(fetchNoticesRequest());
    try{
      const response = await httpbase().get(`resources/notice/?lang=${lang}&page=${page}${branch?'&branch='+branch:''}`);
      const notices = response.data.data || undefined;
      const meta = response.data.meta || undefined;
      dispatch(fetchNoticesSuccess({notices:notices,meta:meta}));
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(fetchNoticesFail(e.response.data));
      }
      dispatch(fetchNoticesFail("Something went wrong!"));
    }
  }
}



export const fetchNoticeBySlug = async (slug:string) =>{
  try{
    const response = await httpbase().get(`resources/notice/${slug}?lang=${lang}`);
    return response.data.data;
  }catch(e){
    console.log(e);
  }
}